import {Component, EventEmitter, Input, Output} from '@angular/core';
import {EntityAlert} from "../../../models/EntityAlert";
import {IEntityAlert} from "../../../models/common";
import {isNullOrUndefined} from "util";
import {TranslateService} from "@ngx-translate/core";
import * as R from "ramda";

@Component({
  selector: 'edsng-global-state',
  templateUrl: './global-state.component.html',
  styleUrls: ['./global-state.component.css']
})
export class GlobalStateComponent {

  @Input() noteGlobal: IEntityAlert;
  @Input() title: string;
  @Input() actionButton: string;
  @Input() actionEnabled = false;
  @Output() onActionButton = new EventEmitter<string>();

  constructor(public translate: TranslateService) {}

  getGlobalErrorMessage(): string {
    const globalMsg = EntityAlert.getMessage(this.noteGlobal, this.translate);
    return R.uniq(R.replace(/; /g, ';', globalMsg).split(';')).join("; ");
  }

  actionButtonClick() {
    if (this.onActionButton) {
      this.onActionButton.emit(this.title);
    }
  }
}
